import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";
import InputError from "../typography/InputError";

const Wrapper = styled.div`
  flex: 1 1 calc(50% - 13px);
  min-width: 250px;
  box-sizing: border-box;

  select {
    box-sizing: border-box;
    padding: 12px 10px;
    border: 1px solid
      ${({ $hasError }) => ($hasError ? colors.black : colors.border)};
    background-color: white;
    color: ${colors.black};
    font-size: ${fontSize.xxs};
    height: 40px;
    width: 100%;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%2010%207%22%20xmlns%3D%22http://www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M0%200l5%207%205-7H0z%22%20fill%3D%22black%22/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 10px 7px;
    border-radius: 0;
    outline: none;
    cursor: pointer;
    text-transform: uppercase;
  }
`;

function Dropdown({ value, onChange, options, placeholder, error }) {
  return (
    <Wrapper $hasError={!!error}>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)}>
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      {error && <InputError error={error} />}
    </Wrapper>
  );
}

export default Dropdown;
